import React from 'react';
import { styled } from 'styled-components';
import { useTranslation } from 'react-i18next';

const ITEM_KEYS = ['keyInfo', 'spelling', 'photoQuality', 'layout', 'safetyZone'] as const;

const ChecklistSection: React.FC = () => {
    const { t } = useTranslation('checkList');

    return (
        <ChecklistContainer>
            {ITEM_KEYS.map((key, index) => {
                const text = t(`items.${key}`);
                const colonIndex = text.indexOf(':');
                const label = colonIndex !== -1 ? text.slice(0, colonIndex + 1) : null;
                const rest = colonIndex !== -1 ? text.slice(colonIndex + 1) : text;
                return (
                    <ChecklistRow key={key}>
                        <ChecklistNumber style={{ backgroundColor: '#111' }}>
                            {index + 1}
                        </ChecklistNumber>
                        <ChecklistText>
                            {label && <ChecklistLabel>{label}</ChecklistLabel>}
                            <ChecklistRegular>{rest}</ChecklistRegular>
                        </ChecklistText>
                    </ChecklistRow>
                );
            })}
        </ChecklistContainer>
    );
};

const ChecklistContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
`;

const ChecklistRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

const ChecklistNumber = styled.div`
    width: 20px;
    height: 20px;
    min-width: 20px;
    border-radius: 50%;
    color: white;
    font-size: 11px;
    font-weight: 700;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ChecklistText = styled.span`
    font-size: 11px;
    line-height: 1.3;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 400;
`;

const ChecklistLabel = styled.span`
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 700;
`;

const ChecklistRegular = styled.span`
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 400;
`;

export default ChecklistSection;
